var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8117 27.2748C18.1645 27.5394 18.5751 27.7164 19.0098 27.7911C19.4444 27.8659 19.8905 27.8363 20.3115 27.7048C20.7324 27.5733 21.1161 27.3437 21.4308 27.0349C21.7456 26.726 21.9825 26.3468 22.1219 25.9284C22.2614 25.51 22.2994 25.0645 22.2329 24.6286C22.1664 24.1926 21.9973 23.7787 21.7394 23.421C21.4816 23.0632 21.1424 22.7718 20.7498 22.5709C20.3573 22.3699 19.9226 22.2651 19.4816 22.2651H2.78271",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3521 11.1325C24.7079 10.6581 25.1791 10.2826 25.7209 10.0415C26.2627 9.80037 26.8571 9.70177 27.4477 9.75503C28.0383 9.80828 28.6055 10.0116 29.0954 10.3457C29.5853 10.6799 29.9817 11.1337 30.2469 11.6641C30.5121 12.1945 30.6373 12.7839 30.6107 13.3763C30.584 13.9687 30.4064 14.5444 30.0946 15.0489C29.7829 15.5533 29.3473 15.9697 28.8294 16.2585C28.3114 16.5473 27.7283 16.6988 27.1353 16.6988H2.78271",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.637 6.12291C13.9898 5.85832 14.4004 5.68134 14.835 5.60658C15.2696 5.53181 15.7158 5.56139 16.1367 5.69288C16.5577 5.82437 16.9413 6.05401 17.2561 6.36286C17.5709 6.67172 17.8078 7.05096 17.9472 7.46932C18.0867 7.88769 18.1247 8.3332 18.0582 8.76916C17.9917 9.20511 17.8225 9.61902 17.5647 9.97677C17.3068 10.3345 16.9677 10.6259 16.5751 10.8268C16.1826 11.0278 15.7479 11.1326 15.3069 11.1326H2.78271",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/ac.04af53d7b7dd89f9d0a216d587b18d58.svg";
export { ForwardRef as ReactComponent };